import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {Forecast, FORECAST_METADATA} from 'smag-commons/dto/msg';
import {Observable} from 'rxjs';
import * as _ from 'lodash';
import {HierarchyEntity, HierarchyService} from '../../../shared/hierarchy.service';

@Component({
    selector: 'app-forecast-details-new',
    templateUrl: './forecast-details-new.component.html',
    styleUrls: ['./forecast-details-new.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForecastDetailsNewComponent implements OnInit {

    @Input() forecast: Forecast;
    @Input() showModels: boolean;

    constructor(private readonly hierarchyService: HierarchyService) {
    }

    ngOnInit() {
    }

    getEntity(f: Forecast): Observable<HierarchyEntity> {
        return this.hierarchyService.findEntityById(f.entity_id);
    }

    getModels(f: Forecast): string {
        if (!f.metadata || !f.metadata[FORECAST_METADATA.MODELS_KEY]) {
            return null;
        }
        return _.sortBy(_.values(f.metadata[FORECAST_METADATA.MODELS_KEY]),
            modelId => modelId).join(', '); // one model id for each quantity type
    }
}
